import { render, staticRenderFns } from "./ListProductionTrailers.vue?vue&type=template&id=78987626&"
import script from "./ListProductionTrailers.vue?vue&type=script&lang=js&"
export * from "./ListProductionTrailers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78987626')) {
      api.createRecord('78987626', component.options)
    } else {
      api.reload('78987626', component.options)
    }
    module.hot.accept("./ListProductionTrailers.vue?vue&type=template&id=78987626&", function () {
      api.rerender('78987626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/special-equipments/ListProductionTrailers.vue"
export default component.exports